/* eslint-disable eqeqeq */
/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import { db, db_modular, auth } from "../firebaseConfig";
import firebase from "firebase/compat/app";
import "firebase/compat/firestore";
// import "./createRoom.css";
import { SHA256 } from "crypto-js";
import { doc, serverTimestamp, setDoc } from "firebase/firestore";
import { UserAuth } from "../context/authContext";
import { toast } from "react-hot-toast";
import "../stylesheet/stylesheet.css";
import { calculateHash } from "../utils/helpers";
import dayjs from "dayjs";
import { FiPlus, FiClock, FiType } from "react-icons/fi";

export const signTransaction = async (transaction, privateKey) => {
  return `signed(${transaction.amount},${transaction.receiver},${privateKey})`;
};

const CreateRoom = () => {
  const [endTime, setEndTime] = useState("");
  const [roomId, setRoomId] = useState(localStorage.getItem("roomId") || "");
  const [roomName, setRoomName] = useState("");
  const [roomType, setRoomType] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [participants, setParticipants] = useState([]);
  const [miners, setMiners] = useState([]);

  const [team, setTeam] = useState("red");
  const [role, setRole] = useState("participant");
  const { user, userData } = UserAuth();
  const [isTransactionSigned, setIsTransactionSigned] = useState(false);
  let [signature, setSignature] = useState(null);
  const [currentRoom, setCurrentRoom] = useState(null);

  useEffect(() => {
    const storedRoomId = localStorage.getItem("roomId");
    if (storedRoomId) {
      const unsubscribe = db
        .collection("rooms")
        .doc(storedRoomId)
        .onSnapshot((doc) => {
          if (doc.exists) {
            setCurrentRoom({ id: doc.id, ...doc.data() });
          } else {
            setCurrentRoom(null);
          }
        });
      return () => unsubscribe();
    }
  }, []);

  const handleLeaveRoom = async () => {
    const storedRoomId = localStorage.getItem("roomId");
    const storedRole = localStorage.getItem("role");
    if (!storedRoomId) return;

    setIsLoading(true);
    try {
      await db
        .collection("rooms")
        .doc(storedRoomId)
        .update({
          [`${storedRole}s`]: firebase.firestore.FieldValue.arrayRemove(userData.publicKey),
        });
      localStorage.removeItem("roomId");
      localStorage.removeItem("role");
      localStorage.removeItem("team");
      setCurrentRoom(null);
      toast.success("Left room successfully.");
    } catch (error) {
      console.error("Error leaving room:", error);
      toast.error("Failed to leave room.");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (!roomId) return;

    const roomRef = db.collection("rooms").doc(roomId);

    const checkEndTimeAndDeleteRoom = (roomData) => {
      if (!roomData) return;

      const endTime = new Date(roomData.endTime).getTime();
      const currentTime = new Date().getTime();

      if (currentTime > endTime) {
        roomRef
          .delete()
          .then(() => {
            toast.success("Room ended due to passing the end time.");
            setRoomId("");
            setParticipants([]);
            localStorage.removeItem("roomId");
          })
          .catch((error) => {
            console.error("Error deleting room:", error);
            toast.error("Error deleting room.");
          });
      }
    };

    const unsubscribe = roomRef.onSnapshot(
      (roomSnapshot) => {
        if (roomSnapshot.exists) {
          const roomData = roomSnapshot.data();
          setParticipants(roomData.participants || []);
          setMiners(roomData.miners || []);
          setEndTime(roomData.endTime);

          checkEndTimeAndDeleteRoom(roomData);
        }
      },
      (error) => {
        console.error("Error fetching room details:", error);
        toast.error("Error fetching room details.");
      }
    );

    return () => unsubscribe();
  }, [roomId]);

  const handleCreateRoom = async () => {
    const existingRoomId = localStorage.getItem("roomId");
    if (existingRoomId) {
      toast.error("You are already in a room. Please leave it first.");
      return;
    }

    setIsLoading(true);
    try {
      const roomRef = await db.collection("rooms").add({
        endTime: endTime,
        createdBy: user.email,
        creatorAddress: userData.publicKey,
        createdAt: new Date(),
        red_participants: team === "red" && role === "participant" ? [userData.publicKey] : [],
        blue_participants: team === "blue" && role === "participant" ? [userData.publicKey] : [],
        red_miners: team === "red" && role === "miner" ? [userData.publicKey] : [],
        blue_miners: team === "blue" && role === "miner" ? [userData.publicKey] : [],
        roomType: "ASTRAHACK",
        roomName: roomName,
        blockCounts: { red: 1, blue: 1 },
      });

      // create initial red team transaction block (genesis)
      const redBlock = {
        sender: userData.publicKey,
        senderEmail: user.email,
        receiver: userData.publicKey,
        timestamp: dayjs().unix(),
        status: "genesis",
        index: 0,
        transactions: [],
        created_at: serverTimestamp(),
      };

      // create initial transaction genesis block for blue team
      const blueBlock = {
        sender: userData.publicKey,
        senderEmail: user.email,
        receiver: userData.publicKey,
        timestamp: dayjs().unix(),
        status: "genesis",
        index: 0,
        transactions: [],
        created_at: serverTimestamp(),
      };

      redBlock.hash = calculateHash([], 0, redBlock.timestamp);
      blueBlock.hash = calculateHash([], 0, blueBlock.timestamp);

      await setDoc(doc(db_modular, "rooms", roomRef.id, "redTeamBlocks", redBlock.hash), redBlock);
      await setDoc(
        doc(db_modular, "rooms", roomRef.id, "blueTeamBlocks", blueBlock.hash),
        blueBlock
      );

      setRoomId(roomRef.id);
      localStorage.setItem("roomId", roomRef.id);
      localStorage.setItem("team", team);
      localStorage.setItem("role", team + "_" + role);

      toast.success("Room created successfully");
      window.location.href = "/joinedhack";
    } catch (error) {
      console.error("Error creating room:", error);
      setErrorMessage("Failed to create room. Please try again later.");
      toast.error(errorMessage);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="w-full flex flex-col h-full">
      <h2 className="text-2xl font-bold text-white mb-6 flex items-center gap-2">
        <div className="p-2 bg-primary/20 rounded-lg text-primary">
          <FiPlus />
        </div>
        Create Room
      </h2>
      {/*   
      {currentRoom && (
        <div className="bg-surfaceHighlight/50 border border-primary/30 rounded-xl p-4 mb-6">
          <div className="flex justify-between items-start mb-3">
            <div>
              <p className="text-primary text-xs font-bold uppercase tracking-wider mb-1">
                You are currently in:
              </p>
              <h3 className="text-lg font-bold text-white">{currentRoom.roomName || "Unnamed Room"}</h3>
              <p className="text-text-muted text-sm">Type: {currentRoom.roomType}</p>
              <p className="text-text-muted text-xs font-mono mt-1">ID: {currentRoom.id}</p>
            </div>
            <button
              onClick={handleLeaveRoom}
              disabled={isLoading}
              className="px-3 py-1.5 bg-red-500/10 text-red-500 border border-red-500/30 rounded-lg text-sm hover:bg-red-500 hover:text-white transition-all font-semibold"
            >
              {isLoading ? "Leaving..." : "Leave Room"}
            </button>
          </div>
        </div>
      )} */}

      <div className="space-y-4 flex-1">
        <div>
          <label className="block text-text-muted text-sm font-medium mb-2">Room Name</label>
          <div className="relative">
            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none text-text-muted">
              <FiType />
            </div>
            <input
              type="text"
              value={roomName}
              onChange={(e) => setRoomName(e.target.value)}
              className="w-full pl-10 pr-4 py-3 bg-surfaceHighlight border border-border rounded-xl text-white placeholder-text-muted focus:outline-none focus:border-primary focus:ring-1 focus:ring-primary transition-colors"
              placeholder="Enter room name"
            />
          </div>
        </div>

        <div>
          <label className="block text-text-muted text-sm font-medium mb-2">Team</label>
          <select
            value={team}
            onChange={(e) => setTeam(e.target.value)}
            className="w-full px-4 py-3 bg-surfaceHighlight border border-border rounded-xl text-white focus:outline-none focus:border-primary focus:ring-1 focus:ring-primary appearance-none transition-colors"
          >
            <option value="red">Red Team (Hacker)</option>
            <option value="blue">Blue Team (Normal)</option>
          </select>
        </div>

        <div>
          <label className="block text-text-muted text-sm font-medium mb-2">Role</label>
          <select
            value={role}
            onChange={(e) => setRole(e.target.value)}
            className="w-full px-4 py-3 bg-surfaceHighlight border border-border rounded-xl text-white focus:outline-none focus:border-primary focus:ring-1 focus:ring-primary appearance-none transition-colors"
          >
            <option value="miner">Miner</option>
            <option value="participant">Participant</option>
          </select>
        </div>

        <div>
          <label className="block text-text-muted text-sm font-medium mb-2">End Time</label>
          <div className="relative">
            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none text-text-muted">
              <FiClock />
            </div>
            <input
              type="datetime-local"
              value={endTime}
              onChange={(e) => setEndTime(e.target.value)}
              className="w-full pl-10 pr-4 py-3 bg-surfaceHighlight border border-border rounded-xl text-white placeholder-text-muted focus:outline-none focus:border-primary focus:ring-1 focus:ring-primary transition-colors [&::-webkit-calendar-picker-indicator]:invert"
              disabled={isLoading}
            />
          </div>
        </div>

        {errorMessage && <p className="text-red-400 text-sm mt-2">{errorMessage}</p>}

        <button
          onClick={handleCreateRoom}
          disabled={isLoading || !endTime || !roomName}
          className={`w-full mt-4 py-3 rounded-xl font-semibold text-white transition-all shadow-lg ${
            isLoading || !endTime || !roomName
              ? "bg-surfaceHighlight text-text-muted cursor-not-allowed"
              : "bg-gradient-to-r from-primary to-secondary hover:shadow-primary/50"
          }`}
        >
          {isLoading ? "Creating..." : "Create Room"}
        </button>
      </div>
    </div>
  );
};

export default CreateRoom;
